/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { css, cx } from '@emotion/css';
import {
  IconDown, IconLeft, IconRight, IconUp,
} from '@americanexpress/dls-react';
import _ from 'lodash';
import { useState, useEffect } from 'react';
import merge from 'deepmerge';

import { useMultiItemSelectContext } from './MultiItemSelectContext';

import multiSelectStyle from '../../styles/MultiItemSelect/MultiItemSelect';

let dragItemIndex = -1;
let dragOrigin = '';

function MultiItemSelectOptions() {
  const {
    options,
    setOptions,
    leftMenuTitle,
    rightMenuTitle,
    allowItemOrdering,
    allowEmptyRightOptions,
    rightMenuNumbering,
    strategy,
    onLeftSelect,
    onRightSelect,
    onLeftItemMove,
    onRightItemMove,
    theme,
    onChange,
    setSelectedItem,
    showError,
    onBlur,
    onFocus,
  } = useMultiItemSelectContext();

  const styleObj = merge.all([multiSelectStyle, theme || {}]);

  const [leftOption, setLeftOption] = useState([]);
  const [rightOption, setRightOption] = useState([]);
  const [leftHighlighted, setLeftHighlighted] = useState(false);
  const [rightHighlighted, setRightHighlighted] = useState(false);
  const [topHighlighted, setTopHighlighted] = useState(false);
  const [downHighlighted, setDownHighlighted] = useState(false);
  const [reRenderLeft, setReRenderLeft] = useState(false);
  const [reRenderRight, setReRenderRight] = useState(false);
  const [primaryItems] = useState(() => options.filter((i) => i.isPrimary)
    .map((i) => i.key));
  const [isFileFlowStrategy] = useState(() => strategy === 'fileFlow'
    && Array.isArray(primaryItems) && primaryItems.length > 0);

  useEffect(() => {
    if ((leftOption.length === 0 && rightOption.length === 0) || isFileFlowStrategy) {
      let updatedOption = _.clone(options);
      if (isFileFlowStrategy) {
        updatedOption = updatedOption.map((x) => {
          x.disable = true;
          if (x.isPrimary === true) {
            x.disable = false;
          }
          return x;
        });
      }
      const filteredLeftOptions = _.clone(updatedOption).filter((item) => item.selected === false)
        .map((item) => item);
      setLeftOption(filteredLeftOptions);
      const filteredRightOptions = _.clone(updatedOption).filter((item) => item.selected === true)
        .map((item) => item);
      setRightOption(filteredRightOptions);
    }
  }, [options]);

  const updateSelectedIem = (setSelectedItemTemp, tempOptionArr) => {
    if (setSelectedItemTemp) {
      setSelectedItemTemp(tempOptionArr);
    }
  };

  useEffect(() => {
    updateSelectedIem(setSelectedItem, rightOption);
  }, [rightOption, setSelectedItem]);

  const isPrimaryHighlighted = (itemList) => itemList
    && itemList.filter((item) => isFileFlowStrategy
      && item && primaryItems.includes(item.key.split('_')[0])).length > 0;

  function resetLeftRightMoveButtons(newLeftOption, newRightOption) {
    if (newLeftOption.filter((item) => item.highlighted === true).length > 0) {
      setLeftHighlighted(true);
    } else {
      setLeftHighlighted(false);
    }
    if (newRightOption.filter((item) => item.highlighted === true).length > 0) {
      setRightHighlighted(true);
    } else {
      setRightHighlighted(false);
    }
    if (allowItemOrdering) {
      const rightHighlightedItem = newRightOption.filter((item) => item.highlighted === true);
      if (rightHighlightedItem.length === 1) {
        const isPrimary = isPrimaryHighlighted(rightHighlightedItem);
        const index = newRightOption.indexOf(rightHighlightedItem[0]);
        if (index > 0) {
          setTopHighlighted(!isPrimary);
        } else {
          setTopHighlighted(false);
        }
        if (index > -1 && index !== (newRightOption.length - 1)) {
          setDownHighlighted(!isPrimary);
        } else {
          setDownHighlighted(false);
        }
      } else {
        setTopHighlighted(false);
        setDownHighlighted(false);
      }
      newRightOption.forEach((item, idx) => {
        item.rank = idx;
      });
      newLeftOption.forEach((item, idx) => {
        item.rank = idx + newRightOption.length;
      });
    }
  }

  const handleDragStart = (e, index, origin) => {
    dragItemIndex = index;
    dragOrigin = origin;
    e.target.style.border = '2px dotted black';
    //   e.target.style.backgroundColor = "transparent";
  };

  // eslint-disable-next-line no-unused-vars
  const handleDragEnd = (e, index, origin) => {
    e.target.style.border = 'none';
  };

  const handleDragEnter = (e, index, origin) => {
    const selectedArr = origin === 'Left' ? [leftOption[index]] : [rightOption[index]];
    const isPrimary = isPrimaryHighlighted(selectedArr);
    if (dragOrigin !== origin || (allowItemOrdering && !isPrimary)) {
      if (origin === 'Left') {
        if (leftOption && leftOption.length > 0) {
          e.target.style.borderTop = '3px solid #006FCF';
        }
      } else if (rightOption && rightOption.length > 0) {
        e.target.style.borderTop = '3px solid #006FCF';
      }
    }
  };

  const handleDragLeave = (e, index, origin) => {
    const selectedArr = origin === 'Left' ? [leftOption[index]] : [rightOption[index]];
    const isPrimary = isPrimaryHighlighted(selectedArr);
    if (dragOrigin !== origin || (allowItemOrdering && !isPrimary)) {
      if (origin === 'Left') {
        if (leftOption && leftOption.length > 0) {
          e.target.style.borderTop = 'none';
        }
      } else if (rightOption && rightOption.length > 0) {
        e.target.style.borderTop = 'none';
      }
    }
  };

  function getUpdatedLeftArr(leftArr, rightArr) {
    let newLeftArr = [...leftArr];
    let newRightArr = [...rightArr];
    if (isFileFlowStrategy) {
      if (Array.isArray(rightArr) && rightArr.length > 0
        && rightArr.filter((i) => i.isPrimary === true).length > 0) {
        newLeftArr = newLeftArr.map((x) => {
          x.disable = x.isPrimary === true;
          return x;
        });
      } else {
        newLeftArr = newLeftArr.map((x) => {
          const notPrimary = !x.isPrimary || x.isPrimary === false;
          x.disable = notPrimary;
          if (notPrimary) {
            x.highlighted = false;
            x.selected = false;
          }
          return x;
        });
        newRightArr = [];
      }
    }
    return { newLeftArr, newRightArr };
  }

  function moveItemToRight(itemsToMoveArr, index) {
    const newRightOptionsArr = [...rightOption];
    const newLeftOptionsArr = [];
    let counter = newRightOptionsArr.length;
    leftOption.forEach((item) => {
      if (itemsToMoveArr.indexOf(item) !== -1) {
        item.highlighted = false;
        item.selected = true;
        // eslint-disable-next-line no-plusplus
        const newItem = isFileFlowStrategy ? { ...item, key: `${item.key}_${counter++}` } : item;
        if (index === -1) {
          newRightOptionsArr.push(newItem);
        } else {
          newRightOptionsArr.splice(index, 0, newItem);
        }
      } else if (!isFileFlowStrategy) {
        newLeftOptionsArr.push(item);
      }
      if (isFileFlowStrategy) {
        newLeftOptionsArr.push(item);
      }
    });

    newRightOptionsArr.forEach((item, currIndex) => {
      if (item.selectionGrp && itemsToMoveArr.indexOf(item) === -1
        && newRightOptionsArr.filter((i) => i.selectionGrp === item.selectionGrp).length > 1) {
        item.highlighted = false;
        item.selected = false;
        if (!isFileFlowStrategy) {
          newLeftOptionsArr.push(item);
          newRightOptionsArr.splice(currIndex, 1);
        }
      }
    });
    const { newLeftArr, newRightArr } = getUpdatedLeftArr(newLeftOptionsArr, newRightOptionsArr);
    setLeftOption(newLeftArr);
    setRightOption(newRightArr);
    resetLeftRightMoveButtons(newLeftArr, newRightArr);
    setOptions([...newLeftArr, ...newRightArr]);
    if (onChange) {
      onChange(newLeftArr, newRightArr);
    }
  }

  function moveItemToLeft(itemsToMoveArr, index) {
    if (rightOption.length > 1 || isFileFlowStrategy || allowEmptyRightOptions) {
      const newRightOptionsArr = [];
      const newLeftOptionsArr = [...leftOption];
      rightOption.forEach((item) => {
        if (itemsToMoveArr.indexOf(item) !== -1) {
          item.highlighted = false;
          item.selected = false;
          if (!isFileFlowStrategy) {
            if (index === -1) {
              newLeftOptionsArr.push(item);
            } else {
              newLeftOptionsArr.splice(index, 0, item);
            }
          }
        } else {
          newRightOptionsArr.push(item);
        }
      });
      const { newLeftArr, newRightArr } = getUpdatedLeftArr(newLeftOptionsArr, newRightOptionsArr);
      setLeftOption(newLeftArr);
      setRightOption(newRightArr);
      resetLeftRightMoveButtons(newLeftArr, newRightOptionsArr);
      setOptions([...newLeftArr, ...newRightArr]);
      if (onChange) {
        onChange(newLeftArr, newRightArr);
      }
    }
  }
  // eslint-disable-next-line complexity
  const handleDrop = (e, i, origin) => {
    e.target.style.borderTop = 'none';
    if (i === dragItemIndex && origin === dragOrigin) {
      return;
    }
    if (origin === dragOrigin) {
      const selectedArr = origin === 'Left' ? [leftOption[i]] : [rightOption[i]];
      const isPrimary = isPrimaryHighlighted(selectedArr);
      const selectedArrDragable = origin === 'Left' ? [leftOption[dragItemIndex]] : [rightOption[dragItemIndex]];
      const isPrimaryDragable = isPrimaryHighlighted(selectedArrDragable);
      if (allowItemOrdering && !(isPrimary || isPrimaryDragable)) {
        if (dragOrigin === 'Left') {
          const itemDropped = leftOption[dragItemIndex];
          const newArr = leftOption;
          newArr.splice(dragItemIndex, 1);
          if (i === -1) {
            newArr.push(itemDropped);
          } else {
            newArr.splice(i, 0, itemDropped);
          }
          setLeftOption(newArr);
          setReRenderLeft(!reRenderLeft);
          resetLeftRightMoveButtons(newArr, rightOption);
          setOptions([...newArr, ...rightOption]);
          if (onChange) {
            onChange(newArr, rightOption);
          }
        } else {
          const itemDropped = rightOption[dragItemIndex];
          const newArr = rightOption;
          newArr.splice(dragItemIndex, 1);
          if (i === -1) {
            newArr.push(itemDropped);
          } else {
            newArr.splice(i, 0, itemDropped);
          }
          setRightOption(newArr);
          updateSelectedIem(setSelectedItem, newArr);
          setReRenderRight(!reRenderRight);
          resetLeftRightMoveButtons(leftOption, newArr);
          setOptions([...leftOption, ...newArr]);
          if (onChange) {
            onChange(leftOption, newArr);
          }
        }
      }
    } else if (dragOrigin === 'Left') {
      const itemDropped = leftOption[dragItemIndex];
      if (rightOption.length < 12) {
        moveItemToRight(Array.of(itemDropped), i);
      } else {
        showError();
      }
    } else {
      const itemDropped = rightOption[dragItemIndex];
      moveItemToLeft(Array.of(itemDropped), i);
    }
  };

  function leftClicked(event, selectedItem) {
    if (selectedItem.highlighted) {
      selectedItem.highlighted = false;
    } else {
      selectedItem.highlighted = true;
    }
    let newArr = [];
    if (isFileFlowStrategy) {
      newArr = leftOption.map((x) => {
        if (selectedItem.key === x.key) {
          x = selectedItem;
        }
        return x;
      });
    } else {
      leftOption.forEach((item) => {
        if (item.highlighted && item.selectionGrp
          && item.selectionGrp === selectedItem.selectionGrp
          && selectedItem.key !== item.key) {
          item.highlighted = false;
        }
        newArr.push(item);
      });
    }
    setLeftOption(newArr);
    resetLeftRightMoveButtons(newArr, rightOption);
    setOptions([...newArr, ...rightOption]);
    if (onChange) {
      onChange(newArr, rightOption);
    }
    onLeftSelect(event, selectedItem);
  }

  function rightClicked(event, selectedItem) {
    const tempSelecetdItem = _.clone(selectedItem);
    if (tempSelecetdItem.highlighted) {
      tempSelecetdItem.highlighted = false;
    } else {
      tempSelecetdItem.highlighted = true;
    }
    const newArr = rightOption.map((x) => {
      if (tempSelecetdItem.key === x.key) {
        x = tempSelecetdItem;
      }
      return x;
    });
    setRightOption(newArr);
    resetLeftRightMoveButtons(leftOption, newArr);
    setOptions([...leftOption, ...newArr]);
    if (onChange) {
      onChange(leftOption, newArr);
    }
    onRightSelect(event, selectedItem);
  }

  function moveToRight() {
    console.log('moveToRight');
    const itemsToMoveArr = leftOption.filter((item) => item.highlighted === true);
    onLeftItemMove(itemsToMoveArr, rightOption, leftOption);
    moveItemToRight(itemsToMoveArr, -1);
  }

  function moveToLeft() {
    console.log('moveToLeft');
    const itemsToMoveArr = rightOption.filter((item) => item.highlighted === true);
    onRightItemMove(itemsToMoveArr, rightOption, leftOption);
    moveItemToLeft(itemsToMoveArr, -1);
  }

  // eslint-disable-next-line no-unused-vars
  function moveToTop(event) {
    const itemsToMoveArr = rightOption.filter((item) => item.highlighted === true);
    const isPrimary = isPrimaryHighlighted(itemsToMoveArr);
    if (itemsToMoveArr.length === 1 && !isPrimary) {
      const item = itemsToMoveArr[0];
      const index = rightOption.indexOf(itemsToMoveArr[0]);
      const newArr = rightOption;
      newArr.splice(index, 1);
      newArr.splice(index - 1, 0, item);
      setRightOption(newArr);
      updateSelectedIem(setSelectedItem, newArr);
      setReRenderRight(!reRenderRight);
      resetLeftRightMoveButtons(leftOption, newArr);
      setOptions([...leftOption, ...newArr]);
      if (onChange) {
        onChange(leftOption, newArr);
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  function moveToDown(event) {
    const itemsToMoveArr = rightOption.filter((item) => item.highlighted === true);
    const isPrimary = isPrimaryHighlighted(itemsToMoveArr);
    if (itemsToMoveArr.length === 1 && !isPrimary) {
      const item = itemsToMoveArr[0];
      const index = rightOption.indexOf(itemsToMoveArr[0]);
      const newArr = rightOption;
      newArr.splice(index, 1);
      newArr.splice(index + 1, 0, item);
      setRightOption(newArr);
      updateSelectedIem(setSelectedItem, newArr);
      setReRenderRight(!reRenderRight);
      resetLeftRightMoveButtons(leftOption, newArr);
      setOptions([...leftOption, ...newArr]);
      if (onChange) {
        onChange(leftOption, newArr);
      }
    }
  }

  const leftSelectMarkup = () => {
    const markup = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const [i, element] of leftOption.entries()) {
      markup.push(
        <div
          id={`multiselect-left-markup-${element.value}`}
          className={cx(
            { [css(styleObj['.optionStyle'])]: true },
            { [css(styleObj['.selected'])]: element.highlighted },
            { [css(styleObj['.selectable'])]: !element.highlighted },
            { [css(styleObj['.disable'])]: element.disable }
          )}
          onClick={(event) => leftClicked(event, element)}
          draggable={true}
          key={`selectable-${i}`}
          onDragStart={(e) => handleDragStart(e, i, 'Left')}
          onDragEnd={(e) => handleDragEnd(e, i, 'Left')}
          onDragEnter={(e) => handleDragEnter(e, i, 'Left')}
          onDragLeave={(e) => handleDragLeave(e, i, 'Left')}
          onDrop={(e) => handleDrop(e, i, 'Left')}
          onDragOver={(e) => e.preventDefault()}
        >
          { element.displayNm ? element.displayNm : element.value}
        </div>
      );
    }
    markup.push(
      <div
        style={{ height: '100%' }}
        key="selectable-a"
        id="multiselect-left-selectable"
        onDragEnter={(e) => handleDragEnter(e, -1, 'Left')}
        onDragLeave={(e) => handleDragLeave(e, -1, 'Left')}
        onDrop={(e) => handleDrop(e, -1, 'Left')}
        onDragOver={(e) => e.preventDefault()}
      >
        <div />
      </div>
    );
    return markup;
  };

  const rightSelectMarkup = () => {
    const markup = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const [i, element] of rightOption.entries()) {
      markup.push(
        <div
          id={`multiselect-right-markup-${element.value}`}
          className={cx(
            { [css(styleObj['.optionStyle'])]: true },
            { [css(styleObj['.selected'])]: element.highlighted },
            { [css(styleObj['.selectable'])]: !element.highlighted }
          )}
          key={`selected-${i}`}
          draggable={true}
          onClick={(event) => rightClicked(event, element)}
          onDragStart={(e) => handleDragStart(e, i, 'Right')}
          onDragEnd={(e) => handleDragEnd(e, i, 'Right')}
          onDragEnter={(e) => handleDragEnter(e, i, 'Right')}
          onDragLeave={(e) => handleDragLeave(e, i, 'Right')}
          onDrop={(e) => handleDrop(e, i, 'Right')}
          onDragOver={(e) => e.preventDefault()}
        >
          { element.displayNm ? `${rightMenuNumbering ? `${i + 1}. ` : ''}${element.displayNm}` : element.value}
        </div>

      );
    }
    markup.push(
      <div
        style={{ height: '100%' }}
        key="selected-a"
        id="multiselect-left-selectable"
        onDragEnter={(e) => handleDragEnter(e, -1, 'Right')}
        onDragLeave={(e) => handleDragLeave(e, -1, 'Right')}
        onDrop={(e) => handleDrop(e, -1, 'Right')}
        onDragOver={(e) => e.preventDefault()}
      >
        <div />
      </div>);
    return markup;
  };

  return (
    <div
      id="multiselect-container"
      className={cx(
        { [css(styleObj['.containerOrder'])]: allowItemOrdering },
        { [css(styleObj['.container'])]: !allowItemOrdering }
      )}
      onBlur={(e) => onBlur(e)}
      onFocus={(e) => onFocus(e)}
      tabIndex="0" // this is onBlue fix as  recommended here ... https://stackoverflow.com/questions/18504139/div-onblur-function
    >
      <div
        id="multiselect-left-menu-title"
        css={styleObj['.heading']}
      >
        {leftMenuTitle}
      </div>
      <div />
      <div
        id="multiselect-right-menu-title"
        css={styleObj['.heading']}
      >
        {rightMenuTitle}
      </div>
      {
                allowItemOrdering
        && <div />
            }
      <div>
        <div
          id="multiselect-left-menu-select"
          css={styleObj['.selectionBox']}
        >
          {leftSelectMarkup()}
        </div>
      </div>
      <div
        id="multiselect-item-reordering"
        css={styleObj['.centerButtonBox']}
      >
        {/* css={`${!leftHighlighted ? styleObj[".disableIcon"]: styleObj[".enableIcon"]}`} */}
        <div className={cx(
          { [css(styleObj['.disableIcon'])]: !leftHighlighted },
          { [css(styleObj['.enableIcon'])]: allowItemOrdering }
        )}
        >
          <IconRight
            id="multiselect-icon-right"
            size="md"
            filled={true}
            onClick={leftHighlighted ? (event) => moveToRight(event) : () => false}
          />
        </div>
        <div
          id="multiselect-center-button"
          css={styleObj['.centerButton']}
        >
          {/* css={`${!rightHighlighted ? styleObj[".disableIcon"]: styleObj[".enableIcon"]}`} */}
          <div
            id="multiselect-center-button-left"
            className={cx(
              { [css(styleObj['.disableIcon'])]: !rightHighlighted },
              { [css(styleObj['.enableIcon'])]: rightHighlighted }
            )}
          >
            <IconLeft
              id="multiselect-icon-left"
              size="md"
              filled={true}
              onClick={rightHighlighted ? (event) => moveToLeft(event) : () => false}
            />
          </div>
        </div>
      </div>
      <div
        id="multiselect-right-menu-select"
        css={styleObj['.selectionBox']}
      >
        {rightSelectMarkup()}
      </div>
      {
                allowItemOrdering
                && (
                <div
                  id="multiselect-center-button-top"
                  css={styleObj['.centerButtonBox']}
                >
                  { /* css={`${!topHighlighted ?
                  styleObj[".disableIcon"]: styleObj[".enableIcon"]}` */}
                  <div
                    id="multiselect-center-button-top-icon-container"
                    className={cx(
                      { [css(styleObj['.disableIcon'])]: !topHighlighted },
                      { [css(styleObj['.enableIcon'])]: topHighlighted }
                    )}
                  >
                    <IconUp
                      id="multiselect-center-button-top-icon"
                      size="md"
                      filled={true}
                      onClick={topHighlighted ? (event) => moveToTop(event) : () => false}
                    />
                  </div>
                  <div
                    id="multiselect-center-button-down"
                    css={styleObj['.centerButton']}
                  >
                    {/* css={`${!downHighlighted ?
                    styleObj[".disableIcon"]: styleObj[".enableIcon"]}`} */}
                    <div
                      id="multiselect-center-button-down-icon-container"
                      className={cx(
                        { [css(styleObj['.disableIcon'])]: !downHighlighted },
                        { [css(styleObj['.enableIcon'])]: downHighlighted }
                      )}
                    >
                      <IconDown
                        id="multiselect-center-button-down-icon"
                        size="md"
                        filled={true}
                        onClick={downHighlighted ? (event) => moveToDown(event) : () => false}
                      />
                    </div>
                  </div>
                </div>
                )
            }
    </div>
  );
}

MultiItemSelectOptions.propTypes = {};

MultiItemSelectOptions.defaultProps = {};

export default MultiItemSelectOptions;
